import React, { useCallback, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Button, Chip, Loader } from '@x5-react-uikit/core';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { toast } from 'react-toastify';

import { Modal } from 'widgets';
import ClientListApi from 'store/services/clientListApi';

import { NEW_FILE } from '../../utils/dictionaries';
import TargetBox from '../TargetBox/TargetBox';
import TooltipX5 from '../../../../widgets/TooltipX5';

interface Props {
  onClose?: () => void;
  isOpen: boolean;
  clientId?: string;
}

const ModalDownload: React.FC<Props> = ({
  onClose = () => {},
  clientId,
  isOpen,
}) => {
  const [files, setFiles] = useState([]);
  const [dispatchCreate, { isLoading: isFileCreating }] =
    ClientListApi.useCreateFileMutation();
  const [dispatchUpdate, { isLoading: isFileUpdating }] =
    ClientListApi.useUpdateFileMutation();

  const isNewFile = clientId === NEW_FILE;

  const handleConfirm = async () => {
    const formData = new FormData();
    try {
      for (let i = 0; i < files.length; i++) {
        formData.append('file', files[i]);
      }

      if (isNewFile) {
        await dispatchCreate(formData).unwrap();
      } else {
        await dispatchUpdate([clientId, formData]).unwrap();
      }

      toast.success('Файл успешно загружен');

      onClose();
    } catch (error) {
      toast.error('Возникла ошибка при загрузке файла');
      console.log('error-47', error);
    }
  };

  const handleFileDrop = useCallback((item: { files: any[] }) => {
    if (item) {
      const files = item.files;
      setFiles(files);
    }
  }, []);

  // prettier-ignore
  const formTitle = isNewFile ? 'Загрузка списка' : 'Загрузка размеченного файла';
  const boxTitle = isNewFile ? 'Файл со списком' : 'Файл с разметкой';
  const isLoading = isFileCreating || isFileUpdating;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      // @ts-ignore
      title={
        <Typography
          variant="h6"
          color="grey.90"
          top="5px"
          position="relative"
          textTransform="uppercase"
          children={formTitle}
        />
      }
      width="400px"
    >
      <Box mt={5}>
        <DndProvider backend={HTML5Backend}>
          <TargetBox
            title={boxTitle}
            onDrop={handleFileDrop}
            isLoading={isLoading}
          />

          {!!files.length && (
            <>
              <Typography component="p" variant="p3" color="grey.90" mt={2}>
                Выбранные файлы:
              </Typography>
              <Box display="flex" flexWrap="wrap" gap={1} mt={2}>
                {files.map((x) => (
                  <TooltipX5 content={x.name}>
                    <Chip label={x.name} maxLabelLength={20} />
                  </TooltipX5>
                ))}
              </Box>
            </>
          )}

          <Box mb={3} />

          <Button
            onClick={handleConfirm}
            disabled={!files.length || isLoading}
            size="medium"
            variant="primary"
          >
            {isLoading ? (
              <Box display="flex" columnGap={2}>
                Загрузка...
                <Loader size="16px" />
              </Box>
            ) : (
              'Загрузить'
            )}
          </Button>
        </DndProvider>
      </Box>
    </Modal>
  );
};

export default ModalDownload;
